import api from './apiClient';

export const configAPI = {
  getPublicConfig: async () => {
    const response = await api.get('/api/config/public');
    return response.data;
  },
};
